import { Box, Grid, InputAdornment, Typography } from '@mui/material';
import { CommonButton, CustomRequiredInputLabel, CustomInputLabel, CustomTextFeildforFamily, CommonOutlinedButton, formatAmount, CustomTextFeild } from '../../common/StyledComponents/StyledFields';
import { useState, useEffect } from 'react';
import { ValidationError, object, string } from 'yup';
import dayjs from 'dayjs';
import { apiRequest, catchErrorMessageHandler } from "../../../infrastructure/backendService";
import { donationTypesProps } from "../../../infrastructure/GlobalContextProvider";
import apiPath from "../../../config/apiPaths.json";
import { PoojaTypeListProps } from "../../../infrastructure/GlobalContextProvider";
import { ClipLoader } from 'react-spinners';
import ButtonLoader from '../../common/ButtonLoader/ButtonLoader';
import { PersonSearch } from '@mui/icons-material';
import ReportsSearchDevotee from '../ReportsSearchDevotee/ReportsSearchDevotee';
import toast from 'react-hot-toast';
import ErrorPopup from '../../common/ErrorPopup';
import CustomSelectField from '../../CompactCustomComponents/CustomSelectField';
import CustomDatePickerField from '../../CompactCustomComponents/CustomDatePickerField';

interface ErrorMessageTypesSearch {
    amountUpperLimit: string
}
const formFieldsDonationReport = {
    searchByDonationDateFrom : dayjs().subtract(7, 'day').format("MM/DD/YYYY"),
    searchByDonationDateTo: dayjs().format("MM/DD/YYYY"),
    searchByMonthly: "",
    searchByQuarterly: "",
    selectYear: "",
    searchYear: "",
    searchCriteria: "",
    amount: "",
    amountUpperLimit: ""
}

/* donation report based on mode */
interface ErrorMessageTypesSearchMode {
    amountUpperLimitMode: string
}

const formFieldsDonationReportByMode = {
    searchByDonationDateFromMode:  dayjs().subtract(7, 'day').format("YYYY-MM-DD"),
    searchByDonationDateToMode: dayjs().format("YYYY-MM-DD"),
    searchCriteriaMode: "",
    donationModeId: "",
    donationTypeId: "",
    poojaId: "",
    signInName: "",
    amountMode: "",
    amountUpperLimitMode: ""
}
/* donation report based on mode */

const DonationReport = ({ sendDataToParent, getReportData }:any) => {
    const [errorMessageBookSummayry, setErrorMessageBookSummary] = useState<ErrorMessageTypesSearch>({ amountUpperLimit:"" });
    const [formDataBookDonationReport, setFormDataBookDonationReport] = useState(formFieldsDonationReport);

    const [errorMessageDonationReportMode, setErrorMessageDonationReportMode] = useState<ErrorMessageTypesSearchMode>({ amountUpperLimitMode:"" });
    const [formDataBookDonationReportMode, setFormDataBookDonationReportMode] = useState(formFieldsDonationReportByMode);

    const [isDateSearch, setIsDateSearch] = useState(false);
    const [isMonthSearch, setIsMonthSearch] = useState(false);
    const [isQuarterlySearch, setIsQuarterlySearch] = useState(false);

    const [donationModes, setDonationModes] = useState<donationTypesProps[]>([]);
    const [donationTypes, setDonationTypes] = useState<donationTypesProps[]>([]);
    const [poojaItemsList, setPoojaItemsList] = useState<PoojaTypeListProps[]>([]);
    const [selectedPoojaId, setSelectedPoojaId] = useState<number | undefined>(0);
    const [selectedDonationModeId, setSelectedDonationModeId] = useState<number | undefined>(0);
    const [selectedDonationTypeId, setSelectedDonationTypeId] = useState<any | undefined>(0);

    const [loading, setLoading] = useState<boolean>(false);
    const [loading_donationPoojaBtn, setLoading_donationPoojaBtn] = useState<boolean>(false);
    
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const Quarterly = [
        "Jan-March",
        "April-June",
        "July-Sept",
        "Oct-Dec"
      ];

      const searchCriteria = [
        "<=",
        ">=",
        "=",
        "><"
      ];

      const validationSchema = object().shape({
        amountUpperLimit:formDataBookDonationReport.searchCriteria === "><" ? string().required("This field is Required") : string()
      });

      const validationSchemaforMode = object().shape({
        amountUpperLimitMode:formDataBookDonationReportMode.searchCriteriaMode === "><" ? string().required("This field is Required") : string()
      });
    
    const generateArrayOfYears = () => {
        let currentYear = new Date().getFullYear();
        var lastTenYears = currentYear - 10;
        var years = [];
      
        for (var i = currentYear; i >= lastTenYears; i--) {
          years.push(i);
        }
        return years;
      };

      useEffect(() => {
        apiRequest({
          method: "GET",
          endpoint: apiPath.donationTypes,
          includeToken: true,
        })
          .then((res) => {
            setDonationModes(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }, []);

      useEffect(() => {
        apiRequest({
          method: "GET",
          endpoint: apiPath.purposeOfDonations,
          includeToken: true,
        })
          .then((res) => {
            setDonationTypes(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }, []);

      useEffect(() => {
        apiRequest({
          method: "GET",
          endpoint: apiPath.poojaTypeByPoojaLocation,
          params: {
            poojaType: "TEMPLE_POOJA",
          },
          includeToken: true,
        })
          .then((res) => {
            setPoojaItemsList(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }, []);

    const handleSearchByDateChange = (field: any, value: any) => {
        if (field === "searchByDonationDateFrom" || field === "searchByDonationDateTo") {
            let formattedDate = dayjs(value, "MM/DD/YYYY");
            setFormDataBookDonationReport({
              ...formDataBookDonationReport,
              [field]: formattedDate.isValid()
                ? formattedDate.format("MM/DD/YYYY")
                : "",
            });
          } else {
            setFormDataBookDonationReport({
                ...formDataBookDonationReport,
                [field]: value,
            });
        }
        switch(field) {
          case "amount" :
            formDataBookDonationReport.amount = value;
            break;
          case "amountUpperLimit" :
            formDataBookDonationReport.amountUpperLimit = value;
            break;
          default :
           break; 
        }
    };

    const handleSearchByDateChangeDonationMode = (field: any, value: any) => {
        if (field === "searchByDonationDateFromMode" || field === "searchByDonationDateToMode") {
            let formattedDate = dayjs(value, "YYYY-MM-DD");
            setFormDataBookDonationReportMode({
              ...formDataBookDonationReportMode,
              [field]: formattedDate.isValid()
                ? formattedDate.format("YYYY-MM-DD")
                : "",
            });
          }else if(field === 'signInName') {
            setFormDataBookDonationReportMode({
                ...formDataBookDonationReportMode,
                [field]: value.toUpperCase(),
            });
        }else{
          setFormDataBookDonationReportMode({
            ...formDataBookDonationReportMode,
            [field]: value,
        });
        }
        if(field === "donationModeId") {
            const selectedDonationMode = donationModes.find(
                (item: any) => item.name === value
              );
              setSelectedDonationModeId(selectedDonationMode?.id);
        }
        if(field === "donationTypeId") {
            const selectedDonationType = donationTypes.find(
                (item: any) => item.accountDescription === value
              );
              setSelectedDonationTypeId(selectedDonationType?.accountNumber);
        }
        if(field === "poojaId") {
            const selectedPooja = poojaItemsList.find(
                (item: PoojaTypeListProps) => item.name === value
              );
            setSelectedPoojaId(selectedPooja?.id);
        }

        switch(field) {
          case "amountMode" :
            formDataBookDonationReportMode.amountMode = value;
            break;
          case "amountUpperLimitMode" :
            formDataBookDonationReportMode.amountUpperLimitMode = value;
            break;
          default :
           break; 
        }
    };

    const getDonationPoojaReports = () => {
      const valueSelected:any = Object.entries(formDataBookDonationReportMode).reduce((a,[k,v]) => (v === "" ? a : ((a as any)[k]=v, a)), {});
      let reqBody:any = {};
      if(valueSelected["searchByDonationDateFromMode"] !== undefined && valueSelected["searchByDonationDateFromMode"] !== "" && valueSelected["searchByDonationDateToMode"] !== undefined && valueSelected["searchByDonationDateToMode"] !== "") {
          reqBody.searchStartDate = valueSelected["searchByDonationDateFromMode"];
          reqBody.searchEndDate = valueSelected["searchByDonationDateToMode"];
      }
      if(selectedDonationModeId !== 0) {
          reqBody.donationModeOfPaymentId = selectedDonationModeId;
      }
      if(selectedPoojaId !== 0) {
          reqBody.poojaTypeId = selectedPoojaId;
      }
      if(selectedDonationTypeId !== 0) {
          reqBody.donationsPurposeId = selectedDonationTypeId;
      }
      reqBody.signInName = valueSelected["signInName"];
      reqBody.searchAmount = valueSelected["amountMode"] || 0;
      reqBody.searchAmountUpperLimit = valueSelected["amountUpperLimitMode"];
      reqBody.searchCriteria = valueSelected["searchCriteriaMode"] || ">=";
      setLoading_donationPoojaBtn(true);
      apiRequest({
          method: "POST",
          endpoint: '/report-dashboard/reports/treasury/DONATION_PUJA_REPORT/browser',
          body: JSON.stringify(reqBody),
          includeToken:true
        })
        .then((res) => {
          setLoading_donationPoojaBtn(false);
          sendDataToParent(true,{reqBody:reqBody,reportName:'Donation Pooja Report',
            formData:formDataBookDonationReportMode
          });
          getReportData(res.data);
          setIsDateSearch(false);
          setIsMonthSearch(false);
          setIsQuarterlySearch(false);
        })
        .catch((err) => {
          setLoading_donationPoojaBtn(false);
          toast.custom(
            <ErrorPopup showMessage={catchErrorMessageHandler(err)} />
          );
        })
    };

    const getDonationReportsByMode = () => {
      const valueSelected:any = Object.entries(formDataBookDonationReport).reduce((a,[k,v]) => (v === "" ? a : ((a as any)[k]=v, a)), {});
      let reqBody:any = {};
      if(valueSelected["searchByDonationDateFrom"] !== undefined && valueSelected["searchByDonationDateFrom"] !== "" && valueSelected["searchByDonationDateTo"] !== undefined && valueSelected["searchByDonationDateTo"] !== "") {
          reqBody.searchStartDate = valueSelected["searchByDonationDateFrom"];
          reqBody.searchEndDate = valueSelected["searchByDonationDateTo"];
      } else if(valueSelected["searchByMonthly"] !== undefined && valueSelected["searchByMonthly"] !== "" && valueSelected["selectYear"] !== undefined && valueSelected["selectYear"] !== "") {
          let monthStartDate = dayjs(new Date(valueSelected["selectYear"], valueSelected["searchByMonthly"])).format("MM/DD/YYYY");
          let monthEndDate = dayjs(new Date(valueSelected["selectYear"], valueSelected["searchByMonthly"]+1, 0)).format("MM/DD/YYYY");
          reqBody.searchStartDate = monthStartDate;
          reqBody.searchEndDate = monthEndDate;
      } else if(valueSelected["searchByQuarterly"] !== undefined && valueSelected["searchByQuarterly"] !== ""  && valueSelected["searchYear"] !== undefined && valueSelected["searchYear"] !== "") {
          let quarterStartDate = dayjs(new Date(valueSelected["searchYear"], valueSelected["searchByQuarterly"])).format("MM/DD/YYYY");
          let quarterEndDate = dayjs(new Date(valueSelected["searchYear"], valueSelected["searchByQuarterly"]+3, 0)).format("MM/DD/YYYY");
          reqBody.searchStartDate = quarterStartDate;
          reqBody.searchEndDate = quarterEndDate;
      }
      reqBody.searchCriteria =  valueSelected["searchCriteria"] || ">=";
      reqBody.searchAmount = valueSelected["amount"] || 0;
      if(valueSelected["searchCriteria"] !== "" && valueSelected["searchCriteria"] === "><") {
          reqBody.searchAmountUpperLimit = valueSelected["amountUpperLimit"];
      }
      reqBody.pagination = true;
      reqBody.pageNumber = 1;
      setLoading(true);
        apiRequest({
            method: "POST",
            endpoint: '/report-dashboard/reports/treasury/DONATION_REPORT/browser',
            body: JSON.stringify(reqBody),
            includeToken:true
          })
          .then((res) => {
            setLoading(false);
            sendDataToParent(true,{reqBody:reqBody,reportName:'Donation Report',
              formData:formDataBookDonationReport,
              totalElements:res.data[0].totalElements,
              pageSize:res.data[0].pagesize
            });
            // getReportData(res.data);  
            let counter = 1;
            const response = res.data[0].data.map((report:any)=>{
              return {
                "Sr.No.":counter++,
                "Sign-in Name":report.username,
                "Name":report.fullName,
                "Address":report.address,
                "Home Phone":report.phoneresidence,
                "Email":report.email,
                "Donation Amount":formatAmount(report.donationamount),
                "Refund Amount":formatAmount(report.refundamount),
            }
              })
            getReportData(response);
          })
          .catch((err) => {
            setLoading(false);
            toast.custom(
              <ErrorPopup showMessage={catchErrorMessageHandler(err)} />
            );
          })
    };

    const handlSubmitSummary = async () => {
        const errors: ErrorMessageTypesSearchMode = {
          amountUpperLimitMode:""
        }
        try {
          await validationSchemaforMode.validate(formDataBookDonationReportMode, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessageDonationReportMode(errors);
            getDonationPoojaReports();
        } catch (error) {
            if (error instanceof ValidationError) {
                error.inner.forEach((e) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypesSearchMode] = e.message;
                    }
                });
            }
            setErrorMessageDonationReportMode(errors);
        }
    };

    const handlSubmitDonationMode = async () => {
        const errors: ErrorMessageTypesSearch = {
            ...formFieldsDonationReport
        }
        try {
           await validationSchema.validate(formDataBookDonationReport, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessageBookSummary(errors);
            getDonationReportsByMode();
        } catch (error) {
            if (error instanceof ValidationError) {
                error.inner.forEach((e) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypesSearch] = e.message;
                    }
                });
            }
            setErrorMessageBookSummary(errors);
        }
    };

    // Search Devotee setters and handlers
    const [openSearchDevotee, setOpenSearchDevotee] = useState(false);

    const handleOpenSearchDevoteeDialog = () => {
      setOpenSearchDevotee(true);
    }

    const handleClose = () => {
      setOpenSearchDevotee(false);
    }

    const hanldeSelectUser = (username: string) => {
      handleSearchByDateChangeDonationMode(
        "signInName",
        username?.toUpperCase()
      );
      handleClose();
    } 

    const FromDatePickerSearchFirst = (): React.ReactElement => {
      return (
        <CustomDatePickerField
          date={formDataBookDonationReportMode.searchByDonationDateFromMode}
          handleDateChange={handleSearchByDateChangeDonationMode}
          errorMessage={undefined}
          name="searchByDonationDateFromMode"
          format="YYYY-MM-DD"
          disableFuture
        />
      );
    };

    const ToDatePickerSearchFirst = (): React.ReactElement => {
      return (
        <CustomDatePickerField
          date={formDataBookDonationReportMode.searchByDonationDateToMode}
          handleDateChange={handleSearchByDateChangeDonationMode}
          errorMessage={undefined}
          name="searchByDonationDateToMode"
          format="YYYY-MM-DD"
          disableFuture
          disabled={isDateSearch}
        />
      );
    };

    const DonationModeDropdownList = (): React.ReactElement => {
        return (
          <>
            <CustomSelectField
              id="grouped-select"
              handleDropdownChange={handleSearchByDateChangeDonationMode}
              errorMessage={""}
              dropDownList={donationModes}
              value={formDataBookDonationReportMode.donationModeId}
              fieldName={"donationModeId"}
              placeholder={"Select Mode"}
              optionLabel={"name"}
              optionValue={"name"}
              overrideStyles={{backgroundColor: "white"}}
            />
          </>
        );
      };

      const DonationTypeDropdownList = (): React.ReactElement => {
        return (
          <>
            <CustomSelectField
              id="grouped-select"
              handleDropdownChange={handleSearchByDateChangeDonationMode}
              errorMessage={""}
              dropDownList={donationTypes}
              value={formDataBookDonationReportMode.donationTypeId}
              fieldName={"donationTypeId"}
              placeholder={""}
              optionLabel={"accountDescription"}
              optionValue={"accountDescription"}
              overrideStyles={{backgroundColor: "white"}}
            />
          </>
        );
      };

      const PoojaListDropdown = (): React.ReactElement => {
        return (
          <>
            <CustomSelectField
              id="grouped-select"
              handleDropdownChange={handleSearchByDateChangeDonationMode}
              errorMessage={""}
              dropDownList={poojaItemsList}
              value={formDataBookDonationReportMode.poojaId}
              fieldName={"poojaId"}
              placeholder={""}
              optionLabel={"name"}
              optionValue={"name"}
              overrideStyles={{ backgroundColor: "white" }}
            />
          </>
        );
      };

    const SelectCriteriaDropDownMode = (): React.ReactElement => {
      return (
        <>
          <CustomSelectField
            id="grouped-select"
            handleDropdownChange={handleSearchByDateChangeDonationMode}
            errorMessage={""}
            dropDownList={searchCriteria?.map((criteria) => ({ criteria }))}
            value={formDataBookDonationReportMode.searchCriteriaMode}
            fieldName={"searchCriteriaMode"}
            placeholder={""}
            optionLabel={"criteria"}
            optionValue={"criteria"}
            overrideStyles={{ backgroundColor: "white" }}
          />
        </>
      );
    };

    const FromDatePickerSearchSecond = (): React.ReactElement => {
      return (
        <CustomDatePickerField
          date={formDataBookDonationReport.searchByDonationDateFrom}
          handleDateChange={handleSearchByDateChange}
          errorMessage={undefined}
          name="searchByDonationDateFrom"
          disableFuture
          disabled={isDateSearch}
        />
      );
    };

    const ToDatePickerSearchSecond = (): React.ReactElement => {
      return (
        <CustomDatePickerField
          date={formDataBookDonationReport.searchByDonationDateTo}
          handleDateChange={handleSearchByDateChange}
          errorMessage={undefined}
          name="searchByDonationDateTo"
          disableFuture
          disabled={isDateSearch}
        />
      );
    };

    const SelectMonthDropdown = (): React.ReactElement => {
      return (
        <CustomSelectField
          id="grouped-select"
          handleDropdownChange={handleSearchByDateChange}
          errorMessage={""}
          dropDownList={months?.map((month: any, index: any) => ({
            month,
            index,
          }))}
          value={formDataBookDonationReport.searchByMonthly}
          fieldName={"searchByMonthly"}
          placeholder={""}
          optionLabel={"month"}
          optionValue={"index"}
          overrideStyles={{ backgroundColor: "white" }}
          readOnly={isMonthSearch}
        />
      );
    };

    const SearchByQuarterlyDropdown = (): React.ReactElement => {
      return (
        <CustomSelectField
          id="grouped-select"
          handleDropdownChange={handleSearchByDateChange}
          errorMessage={""}
          dropDownList={Quarterly?.map((quarter: any, index: any) => ({
            quarter,
            index: index * 3,
          }))}
          value={formDataBookDonationReport.searchByQuarterly}
          fieldName={"searchByQuarterly"}
          placeholder={""}
          optionLabel={"quarter"}
          optionValue={"index"}
          overrideStyles={{ backgroundColor: "white" }}
          readOnly={isQuarterlySearch}
        />
      );
    };

    const SelectByYearDropdown = (): React.ReactElement => {
      return (
        <CustomSelectField
          id="grouped-select"
          handleDropdownChange={handleSearchByDateChange}
          errorMessage={""}
          dropDownList={generateArrayOfYears()?.map((year: any) => ({
            year,
          }))}
          value={formDataBookDonationReport.selectYear}
          fieldName={"selectYear"}
          placeholder={""}
          optionLabel={"year"}
          optionValue={"year"}
          overrideStyles={{ backgroundColor: "white" }}
          readOnly={isMonthSearch}
        />
      );
    };

    const SearchByYear = (): React.ReactElement => {
      return (
        <CustomSelectField
          id="grouped-select"
          handleDropdownChange={handleSearchByDateChange}
          errorMessage={""}
          dropDownList={generateArrayOfYears()?.map((year: any) => ({
            year,
          }))}
          value={formDataBookDonationReport.searchYear}
          fieldName={"searchYear"}
          placeholder={""}
          optionLabel={"year"}
          optionValue={"year"}
          overrideStyles={{ backgroundColor: "white" }}
          readOnly={isQuarterlySearch}
        />
      );
    };

    const SelectCriteriaDropDown = (): React.ReactElement => {
      return (
        <CustomSelectField
          id="grouped-select"
          handleDropdownChange={handleSearchByDateChange}
          errorMessage={""}
          dropDownList={searchCriteria?.map((criteria: any) => ({
            criteria,
          }))}
          value={formDataBookDonationReport.searchCriteria}
          fieldName={"searchCriteria"}
          placeholder={""}
          optionLabel={"criteria"}
          optionValue={"criteria"}
          overrideStyles={{ backgroundColor: "white" }}
        />
      );
    };

    const handleReset = () => {
      setFormDataBookDonationReportMode(formFieldsDonationReportByMode);  
      setSelectedDonationTypeId(null);
      setSelectedDonationModeId(0);
      setSelectedPoojaId(0);
    }

    const handleClear = () => {
      // setFormDataBookDonationReport(formFieldsDonationReport);   
      setFormDataBookDonationReport({...formFieldsDonationReport,searchByDonationDateFrom:"",searchByDonationDateTo:""});   
    }

    const renderDonationPoojaReport = () => {
      return (
        <Box sx={{maxWidth: "450px"}}>
          <Typography className='sub_heading' style={{fontSize: "18px"}}>Donation Pooja Report</Typography>
          <Grid container columnSpacing={"12px"} sx={{ mt: "10px" }}>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search By Donation Date From", true)}
              {FromDatePickerSearchFirst()}
            </Grid>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search By Donation Date To", true)}
              {ToDatePickerSearchFirst()}
            </Grid>
          </Grid>
          <Grid container columnSpacing={"12px"} rowSpacing={"10px"} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search By Donation Mode", true)}
              {DonationModeDropdownList()}
            </Grid>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search By Donation Type", true)}
              {DonationTypeDropdownList()}
            </Grid>
          </Grid>
          <Grid container columnSpacing={"12px"} rowSpacing={"10px"} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Pooja", false)}
              {PoojaListDropdown()}
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomInputLabel>Sign-In Name</CustomInputLabel>
                <CustomTextFeild
                  fullWidth
                  className='text_field compact_fields bg_white'
                  value={formDataBookDonationReportMode.signInName}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    handleSearchByDateChangeDonationMode(
                      "signInName",
                      inputValue
                    );
                  }}
                  onBlur={() => {
                    const inputUserName = formDataBookDonationReportMode.signInName.toUpperCase();
                    handleSearchByDateChangeDonationMode('signInName', inputUserName);
                  }}
                  name="signInName"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PersonSearch sx={{ml: "10px", cursor: "pointer", color: "#F05802"}} onClick={handleOpenSearchDevoteeDialog}/>
                      </InputAdornment>
                    ),
                  }}
                />
            </Grid>
          </Grid>
          <Grid container columnSpacing={"12px"} rowSpacing={"10px"} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search Criteria ", true)}
              {SelectCriteriaDropDownMode()}
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomInputLabel>Amount</CustomInputLabel>
              <CustomTextFeildforFamily
                style={{ minWidth: "100%", borderRadius: "8px" }}
                fullWidth
                value={formDataBookDonationReportMode.amountMode}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^0-9.]/g, '');                  
                  handleSearchByDateChangeDonationMode(
                    "amountMode",
                    inputValue
                  );
                }}
                className='text_field compact_fields bg_white'
              />
            </Grid>
          </Grid>
          <Grid container sx={{ mt: "10px" }} columnSpacing={"12px"}>
            <Grid item xs={12}>
              <CustomInputLabel>
                If you have selected {"><"} search criteria, enter higher amount
                here
              </CustomInputLabel>
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextFeild
                fullWidth
                value={formDataBookDonationReportMode.amountUpperLimitMode}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^0-9.]/g, '');
                  handleSearchByDateChangeDonationMode(
                    "amountUpperLimitMode",
                    inputValue
                  );
                  setErrorMessageDonationReportMode({...errorMessageDonationReportMode, amountUpperLimitMode:""})
                }}
                className='text_field compact_fields bg_white'
              />
              {errorMessageDonationReportMode.amountUpperLimitMode ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessageDonationReportMode.amountUpperLimitMode}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
          <Grid sx={{ mt: "16px", display: "flex", gap: "1rem" }}>
            <CommonButton
              sx={{ width: "fit-content", height: "38px" }}
              onClick={handlSubmitSummary}
              disabled={loading_donationPoojaBtn}
              id="submit"
            >
              <ButtonLoader isBtnLoading={loading_donationPoojaBtn} btnText={'Submit'} />
            </CommonButton>
            <CommonOutlinedButton onClick={handleReset}>Reset</CommonOutlinedButton>
          </Grid>
        </Box>
      )
    }

    const renderDonationReport = () => {
      return (
        <Box sx={{maxWidth: "450px"}}>
          <Typography className='sub_heading' style={{fontSize: "18px"}}>Donation Report</Typography>
          <Grid container columnSpacing={"12px"} sx={{ mt: "10px" }}>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search By Donation Date From", true)}
              {FromDatePickerSearchSecond()}
            </Grid>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search By Donation Date To", true)}
              {ToDatePickerSearchSecond()}
            </Grid>
          </Grid>
          <Grid container columnSpacing={"12px"} rowSpacing={"10px"} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search By Monthly", false)}
              {SelectMonthDropdown()}
            </Grid>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Select By Year", false)}
              {SelectByYearDropdown()}
            </Grid>
          </Grid>
          <Grid container columnSpacing={"12px"} rowSpacing={"10px"} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search By Quarterly", false)}
              {SearchByQuarterlyDropdown()}
            </Grid>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search By Year", false)}
              {SearchByYear()}
            </Grid>
          </Grid>
          <Grid container columnSpacing={"12px"} rowSpacing={"10px"} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={6}>
              <CustomInputLabel>Amount</CustomInputLabel>
              <CustomTextFeild
                fullWidth
                value={formDataBookDonationReport.amount}
                onChange={(e) => {
                  const inputValue =e.target.value.replace(/[^0-9.]/g, '');
                  handleSearchByDateChange("amount", inputValue);
                }}
                className='text_field compact_fields bg_white'
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {CustomRequiredInputLabel("Search Criteria", false)}
              {SelectCriteriaDropDown()}
            </Grid>
          </Grid>
          <Grid container columnSpacing={"12px"} sx={{ mt: "10px" }}>
            <Grid item xs={12}>
              <CustomInputLabel>
                If you have selected {"><"} search criteria, enter higher amount
                here
              </CustomInputLabel>
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextFeild
                fullWidth
                value={formDataBookDonationReport.amountUpperLimit}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^0-9.]/g, '');
                  handleSearchByDateChange("amountUpperLimit", inputValue);
                  setErrorMessageBookSummary({...errorMessageBookSummayry, amountUpperLimit:""})
                }}
                className='text_field compact_fields bg_white'
              />
               {errorMessageBookSummayry.amountUpperLimit ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageBookSummayry.amountUpperLimit}
              </Typography>
            ) : (
              ""
            )}
            </Grid>
          </Grid>
          <Grid sx={{ mt: "16px", display: "flex", gap: "1rem" }}>
            <CommonButton
              sx={{ width: "fit-content", height: "38px" }}
              onClick={handlSubmitDonationMode}
              disabled={loading}
              id="submit"
            >
              {loading ? (
                <>
                  <ClipLoader color="#fff" loading={loading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Submitting...
                  </span>
                </>
              ) : (
                "Submit"
              )}
            </CommonButton>
            <CommonOutlinedButton onClick={handleClear}>Clear</CommonOutlinedButton>
          </Grid>
        </Box>
      )
    }

    return (
      <>
        <Grid container spacing={"24px"}>
          <Grid item xs={12} md={6}>
            {renderDonationPoojaReport()}
          </Grid>
          <Grid item xs={12} md={6}>
            {renderDonationReport()}
          </Grid>
        </Grid>
        {openSearchDevotee && (
          <ReportsSearchDevotee
            open={openSearchDevotee}
            handleClose={handleClose}
            hanldeSelectUser={hanldeSelectUser}
          />
        )}
      </>
    );
}
export default DonationReport;